import { createFileRoute, redirect } from "@tanstack/react-router";
import { HelmCompass } from "@/components/helm-logo";
import { LoginForm } from "@/components/login-form";
import { AuthMarketingPanel } from "@/components/auth-marketing-panel";
import { Card, CardContent } from "@/components/ui/card";

export const Route = createFileRoute("/_auth/login")({
	component: RouteComponent,
	beforeLoad: async ({ context }) => {
		if (context.auth.isAuthenticated()) {
			throw redirect({ to: "/" });
		}
	},
});

function RouteComponent() {
	return (
		<div className="relative grid min-h-svh lg:grid-cols-2">
			{/* ── Left: Form panel ── */}
			<div className="flex flex-col gap-4 p-6 md:p-10">
				<div>
					<div className="flex justify-center gap-2 md:justify-start">
						<div className="flex items-center gap-2.5 font-medium">
							<HelmCompass size={24} color="hsl(22 82% 31%)" strokeWidth={1.2} />
							<span
								className="font-display text-sm"
								style={{ letterSpacing: "0.18em" }}
							>
								H E L M
							</span>
						</div>
					</div>
					{/* Decorative accent line */}
					<div className="hidden md:block mt-4 h-0.5 w-36 bg-primary rounded-full" />
				</div>
				<div className="flex flex-1 items-center justify-center">
					<div className="w-full max-w-md">
						<Card>
							<CardContent>
								<LoginForm />
							</CardContent>
						</Card>
					</div>
				</div>
			</div>

			{/* ── Right: Marketing panel with dashboard preview ── */}
			<AuthMarketingPanel />

			{/* Footer */}
			<div className="absolute bottom-4 left-0 right-0 flex justify-center gap-4 text-xs text-muted-foreground lg:justify-start lg:left-6 lg:right-auto">
				<a href="/terms" target="_blank" rel="noopener noreferrer" className="hover:text-foreground">
					Terms of Service
				</a>
				<a href="/privacy" target="_blank" rel="noopener noreferrer" className="hover:text-foreground">
					Privacy Policy
				</a>
			</div>
		</div>
	);
}
